import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxControl } from '../components/Form/Controls/CheckboxControl';
import { InfoTooltip } from '../components/InfoTooltip';
import { formatClassName, pickDataAttributes } from '../utils';
import isEmpty from 'lodash/isEmpty';
import { kebabCase } from 'lodash';
import { Box, Flex, Text } from '@chakra-ui/react';

const getDataAction = ({ children, label }) => {
  const dataActionLabel = children?.props?.children || children || label || 'checkbox';
  return `check-${kebabCase(dataActionLabel)}`;
};

export const MaterialCheckbox = props => {
  const hasTooltip = !isEmpty(props.tooltip);
  const hasHelpLine = !isEmpty(props.helpLine);
  const dataAttributes = pickDataAttributes(props, 'checkbox');
  if (!dataAttributes['data-action']) {
    dataAttributes['data-action'] = getDataAction(props);
  }

  const defaultPadding = { pt: 0, pr: 4, pb: 0, pl: 0 };
  const userPadding = props.padding || {};
  const padding = {
    ...defaultPadding,
    ...userPadding,
    right: hasTooltip ? 0 : userPadding.pr || defaultPadding.pr,
  };

  const className = formatClassName(['checkbox', 'col-form-label', props.className, { 'has-tooltip': hasTooltip }]);

  return (
    <Box as="span" className="checkbox-container">
      <Flex align="start" direction="column">
        <Flex>
          <CheckboxControl {...props} padding={padding} {...dataAttributes} className={className}>
            {props.children || props.label}
          </CheckboxControl>
          {hasTooltip && (
            <Box h="29px">
              <InfoTooltip {...props.tooltip} />
            </Box>
          )}
        </Flex>
        {hasHelpLine && (
          <Text style={{ margin: '-12px 0 8px 0' }} fontSize="xs" pl={6}>
            {props.helpLine}
          </Text>
        )}
      </Flex>
    </Box>
  );
};

MaterialCheckbox.propTypes = {
  chakra: PropTypes.bool,
  inline: PropTypes.bool,
  checked: PropTypes.bool,
  children: PropTypes.any,
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  helpLine: PropTypes.string,
  padding: PropTypes.object,
  onChange: PropTypes.func,
  tooltip: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipPosition: PropTypes.string,
    buttonClass: PropTypes.string,
  }),
};
